import reducer from './reducer';

export const { addTime } = reducer.actions;
